__turbopack_context__.v({
  "grid": "broadcastGrid-module-scss-module__-Xr1mW__grid",
  "icon": "broadcastGrid-module-scss-module__-Xr1mW__icon",
});
